import { useSelector } from "react-redux";
import { Cart } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCart = (): Cart => useSelector(getCart);

const getCart = (state: StoreState): Cart => {
  if (!state.cart) {
    return undefined;
  }

  return state.cart;
};
